import { useState } from 'react';
import styled from 'styled-components';
import ButtonLink from './ButtonLinkComponent';
import { device } from '../../utils/styled-component-mixins';

const FeaturedContentStyled = styled.article`
  background-color: var(--white);
  box-shadow: 0px 16px 80px rgba(91, 110, 127, 0.25);
  margin-top: 4.8rem;
  overflow: hidden;
  padding: 1.6rem 2.4rem 2.4rem 2.4rem;
  position: absolute;
  right: 7rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;

  @media ${device.desktop} {
    margin-top: 1rem;
    max-width: 26.9rem;
    padding: 1.6rem 2.4rem 1.6rem 2.4rem;
  }

  .animation-wrapper {
    @media ${device.desktop} {
      height: 100%;
      overflow: hidden;

      &:after {
        background-color: var(--bdo-red);
        content: '';
        height: 110%;
        position: absolute;
        top: 0;
        transform: skewX(50deg);
        transition: all 0.3s ease-in;
        width: 375%;
        z-index: 1;
        animation: translate-right 0.3s forwards;
      }

      &.hover-in {
        animation: translate-right 0.3s forwards;

        &:after {
          animation: translate-right 0.3s forwards;
          background-color: var(--slate);
        }

        .featured-content-copy {
          h2,
          p,
          a {
            transition: color 0.3 ease-in;
            color: var(--white);
          }
        }

        a {
          transform: translateX(0);
        }
      }

      &.hover-out {
        animation: translate-left 0.3s forwards;

        &:after {
          animation: translate-left 0.3s forwards;
        }
        a {
          transform: translateX(calc(-100% + 22px));
        }
      }

      a {
        line-height: 1rem;
      }
    }
  }

  h2 {
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2.4rem;
    margin-bottom: 0.8rem;

    @media ${device.desktop} {
      font-size: 1.6rem;
    }
  }

  .featured-content-copy {
    position: relative;
    z-index: 100;
  }

  .featured-content-description {
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 1.6rem;

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  a {
    border-bottom: 0;
    font-size: 1.4rem;
    line-height: 1.8rem;
    transition: all 0.3s ease-in-out;

    &:hover {
      span:first-child {
        background-size: 0;
      }
    }

    span:first-child {
      transition: none;
    }

    .material-icons-round {
      align-items: center;
      display: flex;
      font-size: 3.2rem;
      height: 1.6rem;
    }
  }

  @keyframes translate-right {
    from {
      right: 210%;
    }

    to {
      right: -150%;
    }
  }

  @keyframes translate-left {
    from {
      right: -150%;
    }

    to {
      right: 210%;
    }
  }
`;

const FeaturedContent = (props) => {
  const { description, heading, linkText, linkUrl } = props;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <FeaturedContentStyled
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="featured-content-card"
    >
      <div className={`animation-wrapper ${isHovered ? 'hover-in' : 'hover-out'}`}>
        <div className="featured-content-copy">
          <h2>{heading}</h2>
          <div
            className="featured-content-description"
            dangerouslySetInnerHTML={{ __html: description }}
          ></div>
          <ButtonLink type="tertiary" text={linkText} link={linkUrl} theme="light" />
        </div>
      </div>
    </FeaturedContentStyled>
  );
};

export default FeaturedContent;
